<template>
  <button
    type="button"
    class="ws-cli-chip ws-cli-chip--user"
    :class="{ 'ws-cli-chip--active': active }"
    @click="$emit('click')"
  >
    <span class="ws-cli-chip__avatar-wrap">
      <img
        v-if="photoUrl"
        :src="photoUrl"
        :alt="displayName"
        class="ws-cli-chip__avatar"
      />
      <span v-else class="ws-cli-chip__avatar ws-cli-chip__avatar--initials">{{ initials }}</span>
    </span>
    <span class="ws-cli-chip__label">{{ displayName }}</span>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { getUserDisplayName, getUserInitials, getUserPhotoUrl } from '@/utils/userDisplay'

const props = defineProps({
  user: { type: Object, required: true },
  active: { type: Boolean, default: false }
})

defineEmits(['click'])

const displayName = computed(() => getUserDisplayName(props.user))
const initials = computed(() => getUserInitials(props.user))
const photoUrl = computed(() => getUserPhotoUrl(props.user))
</script>
